import React, { useState, useEffect } from 'react'
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import configModule from "../../config";
import { FaAngleRight } from "react-icons/fa";
import Footer from "./footer";
import SvgContent from "../components/Svgcontent";
import { decode } from "he";

function ExamLists() {
  const [searchParams] = useSearchParams();
  const config = configModule.config();
  const id = searchParams.get("id");
  const [examList, setExamList] = useState([]);
  const navigate = useNavigate();
  const { state } = useLocation();

  const fetchExamCategory = async (id) => {
    try {

      const response = await axios.get(
        `${config.apiBaseUrl}/get-exambycategory?category_id=${id}`,
        {
          headers: {
            "x-api-key": config.apichKey,
          },
        }
      );

      setExamList(response.data);
    } catch (error) {
      console.error("Error fetching exams:", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchExamCategory(id);
    }
  }, [id]);

  function decodeHTML(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  function cleanHTML(html) {
    return html.replace(/<\/?p>/g, "");
  }

  const slugify = (name) =>
    name
      ?.split(" ")
      .map(word => {
        if (word.toUpperCase() === word) return word;
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join("-");

  return (
    <div className="scscholmain-container">
      {/* Banner */}
      <div className="cl-hero-banner" style={{ height: "92px" }}>
        <div className="cl-hero-pattern"></div>
        <div className="cl-hero-text">
          <h2>{state?.item ? <SvgContent svg_name={state?.item.icon_class_name} stroke="#fff" /> : ""} {state?.item?.category + " - " || ""}Exam List</h2>
        </div>

        <span className="breadcrumb-st" > <span className="gotohome-st" onClick={() => navigate("/")} >Home</span> <FaAngleRight className="arrow_icon" /> <b>Exam Lists</b> </span>
      </div>

      <div className="sccontainer-st">

        <div className="exfoot-row-mainst exlist-row-mainst">
          {examList.map((item) => (
            <div className="exfoot-innerrow-main-st exlist-innerrow-main-st align-items-start" key={item?.id}
              onClick={() =>
                navigate(`/${item.id}/exam-details/${slugify(decode(item.title))}`, {
                  state: item,
                })
              } >
              <div className="divexamicon-st">
                <img src={item.icon} align={item.icon} className="examicon-st" />
              </div>
              <div className="rightcont-elst">
                <p className="textstfootex text-left-st">{item.title}</p>
                <div
                  dangerouslySetInnerHTML={{
                    __html: cleanHTML(decodeHTML((item.description?.length > 420
                      ? item.description.substring(0, 420) + "..."
                      : item.description) || ""))
                  }}
                />
              </div>
            </div>
          ))}
        </div>

        {
          examList.length === 0 && (
            <div className="text-center py-5" style={{ minHeight: "100vh" }}>
              <h5>No Exams Found..!</h5>
            </div>
          )
        }
      </div >

      <Footer />
    </div >
  )
}

export default ExamLists;
